// Wybór sprzętu do wydruku etykiet i orientacja w podglądzie (2026-09-29).
//
// Strona etykiet musi działać tak samo dla jednej sztuki (przycisk w szczegółach sprzętu)
// jak dla całego magazynu. Przy kilkuset sztukach płaska lista i wszystkie arkusze naraz
// przestawały być czytelne, więc lista jest grupowana po kategorii, a podgląd pokazuje jeden
// arkusz i miniatury pozostałych. Tu siedzi wyłącznie logika (bez React), żeby dało się ją
// sprawdzić testem.

import { labelCodeFor } from './equipmentCode';
import { foldText as fold } from './foldText';

/** Czy sztuka pasuje do wpisanej frazy (nazwa, marka, numer, kod na etykiecie, kategoria). */
export function matchesQuery(item, query) {
  const q = fold(query).trim();
  if (!q) return true;
  const hay = [item.name, item.brand, item.inventory_number, item.category, labelCodeFor(item)]
    .map(fold)
    .join(' ');
  return q.split(/\s+/).every((word) => hay.includes(word));
}

/**
 * Grupy po kategorii, alfabetycznie; sztuki bez kategorii na końcu.
 * `key` grupy jest stały niezależnie od języka panelu (pusty napis = bez kategorii).
 */
export function groupItems(items, { query = '' } = {}) {
  const byKey = new Map();
  for (const item of items) {
    if (!matchesQuery(item, query)) continue;
    const key = String(item.category || '').trim();
    if (!byKey.has(key)) byKey.set(key, []);
    byKey.get(key).push(item);
  }
  const byName = (a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'pl')
    || String(labelCodeFor(a)).localeCompare(String(labelCodeFor(b)), 'pl');
  return [...byKey.entries()]
    .map(([key, list]) => ({ key, items: list.sort(byName) }))
    .sort((a, b) => {
      if (!a.key) return 1;
      if (!b.key) return -1;
      return a.key.localeCompare(b.key, 'pl');
    });
}

/** Stan pola wyboru grupy: 'all' | 'some' | 'none'. */
export function groupState(group, isSelected) {
  const n = group.items.filter((i) => isSelected(i)).length;
  if (n === 0) return 'none';
  return n === group.items.length ? 'all' : 'some';
}

/** Pierwsze wystąpienie każdej sztuki na arkuszach: id → { page, slot }. */
export function locateItems(pages) {
  const at = new Map();
  pages.forEach((page, pi) => {
    page.forEach((item, si) => {
      if (item && !at.has(Number(item.id))) at.set(Number(item.id), { page: pi, slot: si });
    });
  });
  return at;
}

/**
 * Co stoi w każdym polu arkusza — do miniatury: 'item' (etykieta), 'skip' (pole pominięte na
 * napoczętym arkuszu, tylko na pierwszej stronie), 'empty' (wolne pole na końcu wydruku).
 */
export function slotStates(page, { pageIndex, perPage, skip = 0 }) {
  const out = [];
  for (let i = 0; i < perPage; i += 1) {
    if (i < page.length && page[i]) out.push('item');
    else if (pageIndex === 0 && i < skip) out.push('skip');
    else out.push('empty');
  }
  return out;
}

/** „A, B, C i 4 innych” — baner nie może wypisać dwustu nazw. */
export function shortList(names, { max = 5, more = (n) => `+${n}` } = {}) {
  if (names.length <= max) return names.join(', ');
  return `${names.slice(0, max).join(', ')} ${more(names.length - max)}`;
}
